﻿import React from 'react';

import { EIntegration } from 'pages/partners/components/IntegrationsTab/constants';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { IntegrationVendor } from 'apis/PartnerApi';
import { Col, Row } from 'react-bootstrap';

type XEDIntegrationProps = {
    copyClipboardWithMessage: (copyText: string) => void;
    integration: IntegrationVendor;
    resyncIntegrationClick: (orderId: number, syncingIntegration: EIntegration) => Promise<void>
}

export const XEDIntegration = ({ copyClipboardWithMessage, integration, resyncIntegrationClick }: XEDIntegrationProps) => {

    const { formatMessage } = useIntl();
    return (
        <>
            <h5 className="my-3 integrations__title">
                {integration.VendorName}
                {' '}
                <FormattedMessage defaultMessage="Integration" id="integration.d25f52d8" />
            </h5>
            <Row key={integration.VendorId}>
                <Col className="mb-3 col-12 col-lg-4">
                    <Row>
                        <Col className="col-8">
                            <GMetrixInput
                                readOnlyNoLock
                                label={formatMessage({ id: 'external_partner_id.53d02e2f', defaultMessage: 'External Partner ID' })}
                                value={integration.IntegrationId}
                            />
                        </Col>
                        <Col className="d-flex align-items-end col-4">
                            <GMetrixButton onClick={() => integration.IntegrationId && copyClipboardWithMessage(integration.IntegrationId)} variant='primary' >
                                <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                            </GMetrixButton>
                        </Col>
                    </Row>
                </Col>
                {integration.ErrorMessage.length > 0 && (
                    <Col className="mb-3 d-flex align-items-bottom" md={4}>
                        <div className="flex-column integrations__error">
                            <p className="mt-2 mt-md-0 p-2">
                                {integration.ErrorMessage}
                            </p>
                            <GMetrixButton
                                className="m-2"
                                onClick={() => resyncIntegrationClick(integration.OrderId, integration.VendorId)}
                                variant="primary"
                            >
                                <FormattedMessage defaultMessage="Retry to Sync" id="retry_to_sync.964eb759" />
                            </GMetrixButton>
                        </div>
                    </Col>
                )}
            </Row>
            <hr />
        </>
    );

};